// extracted by mini-css-extract-plugin
export default {"orderNumber":"UserContentTable_orderNumber__zMzKT"};